import React from "react";

export default function BsMusicNoteBeamed() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 19.58c0 1.658-1.68 3-3.75 3-2.07 0-3.75-1.342-3.75-3 0-1.655 1.68-3 3.75-3 2.07 0 3.75 1.345 3.75 3Zm13.5-3c0 1.658-1.68 3-3.75 3-2.07 0-3.75-1.342-3.75-3 0-1.657 1.68-3 3.75-3 2.07 0 3.75 1.343 3.75 3Z"
        fill="#currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 16.58V3.08h1.5v13.5H21Zm-12-12v15H7.5v-15H9Z"
        fill="#currentColor"
      />
      <path
        d="M7.5 4.438a1.5 1.5 0 0 1 1.35-1.492l12-1.2a1.5 1.5 0 0 1 1.65 1.492v1.343l-15 1.5V4.438Z"
        fill="#currentColor"
      />
    </svg>
  );
}
